import { isEmptyVal } from '@/utils';
import { planTypes } from '@/common/constants';
import { flowTypes } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';

// Driver
// urls & page config may not be as expected
// they are sometimes strange, eg. type=add means add2cart
// (1, parse url & page config; 2, flatten the diff) => change page config => target flow

export default [
  {
    // buynow
    test: ({ type }) => (type === flowTypes.buyNow || isEmptyVal(type)),
    config({ from, plan }) {
      return {
        type: flowTypes.buyNow,
        editConfig: {
          planType: getPlanTypeByCategory(from || plan || 'pro'),
          category: from || plan || 'pro'
        },
      };
    },
  },
  {
    // basic2pro
    test: ({ type }) => type === flowTypes.basic2pro,
    config({ type, from, plan }) {
      return {
        type,
        editConfig: {
          planType: getPlanTypeByCategory(from || plan || 'pro'),
          category: from || plan || 'pro'
        },
      };
    },
  },
  {
    // pro2biz
    test: ({ type }) => type === flowTypes.pro2biz,
    config({ type, plan }) {
      return {
        type,
        editConfig: {
          plan,
          targetCategory: plan,
          planType: planTypes.ZOOM_MEETING,
        },
      };
    },
  },
  {
    // upgrade
    test: ({ type }) => type === flowTypes.upgrade,
    config({ type, plan }) {
      return {
        type,
        editConfig: {
          plan,
          targetCategory: plan,
          planType: planTypes.ZOOM_MEETING,
        },
      };
    },
  },
  {
    // add2cart
    test: ({ type, subPlan }) => type === 'add' && subPlan === 'newsubs',
    config({ from_sub, from, campaign_code, trial_code /* FREE TRIAL - free trial plan expired need to add paid plan */ }) {
      return {
        type: flowTypes.add2cart,
        editConfig: {
          planType: getPlanTypeByCategory(from_sub || from),
          category: from_sub || from,
          campaign_code,
          trial_code
        },
      };
    },
  },
  {
    // edit
    test: ({ type }) => type === flowTypes.edit,
    config({ type, plan, oldPlanCode, subPlan }) {
      const isBase = subPlan === 'none';
      const category = isBase ? plan : subPlan
      const planType = getPlanTypeByCategory(category);
      return {
        type,
        editConfig: {
          plan,
          oldPlanCode,
          planType,
          category
        },
      };
    },
  },
  {
    // downgrade
    test: ({ type }) => type === flowTypes.downgrade,
    config({ type, plan, oldPlanCode, from }) {
      const planType = getPlanTypeByCategory(from || plan);
      return {
        type,
        editConfig: {
          plan,
          oldPlanCode,
          planType,
          category: from || plan,
        },
      };
    },
  },
  {
    // trial2paid
    test: ({ type }) => type === flowTypes.trial2paid,
    config({ subPlan, oldPlanCode, campaign_code, trial_code /* FREE TRIAL - online free trial plan upgrade to paid plan */ }) {
      const planType = getPlanTypeByCategory(subPlan);
      return {
        editConfig: {
          oldPlanCode,
          planType,
          category: subPlan,
          campaign_code,
          trial_code
        },
      };
    },
  },
  {
    // BUY TRIAL - buy trial
    test: ({ type }) => type === flowTypes.buyTrial,
    config({ from_sub, from, campaign_code }) {
      return {
        type: flowTypes.buyTrial,
        editConfig: {
          planType: getPlanTypeByCategory(from_sub || from),
          category: from_sub || from,
          campaign_code
        },
      };
    }
  },
  {
    // FREE TRIAL - add2trial
    test: ({ type }) => type === flowTypes.add2trial,
    config({ from_sub, from, campaign_code }) {
      return {
        type: flowTypes.add2trial,
        editConfig: {
          planType: getPlanTypeByCategory(from_sub || from),
          category: from_sub || from,
          campaign_code
        },
      };
    }
  },
  {
    // mix buy
    test: ({ type }) => type === flowTypes.mixBuy,
    config() {
      return {
        type: flowTypes.mixBuy,
        editConfig: {
          planType: "",
          category: "",
        },
      };
    },
  },
  {
    // biz2bundle
    test: ({ type }) => type === flowTypes.biz2bundle,
    config() {
      return {
        type: flowTypes.biz2bundle,
        editConfig: {
          planType: planTypes.ZOOM_ONE_BUNDLE,
        },
      };
    },
  },
  {
    // pro2zone_proplus
    test: ({ type }) => type === flowTypes.pro2prop,
    config() {
      return {
        type: flowTypes.pro2prop,
        editConfig: {
          planType: planTypes.ZONE_PRO_PLUS,
        },
      };
    },
  },
  {
    // prop2bundle
    test: ({ type }) => type === flowTypes.prop2bundle,
    config() {
      return {
        type: flowTypes.prop2bundle,
        editConfig: {
          planType: planTypes.ZOOM_ONE_BUNDLE,
        },
      };
    },
  },
];
